/* eslint-disable react-hooks/exhaustive-deps */

import { ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import DataContentEditForm from "./DataContentEditForm"

/* Protopia Ecosystem component */
export interface IDataContentEditorProps {
   data: any
   section?:ILandingSection
}
const DataContentEditor = (props: IDataContentEditorProps): JSX.Element => {
    return <></>
}

export {
    DataContentEditForm
}
export default DataContentEditor